var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftDisabled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "keyboard_arrow_left"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "keyboard_arrow_left_2",
    d: "M13.9998 18L7.9998 12L13.9998 6L15.3998 7.4L10.7998 12L15.3998 16.6L13.9998 18Z",
    fill: "#999E9C"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left-disabled.af235552002413f9c243367c29c28984.svg";